import { QuickEditFieldModel } from './QuickEditField';

export interface IQuickEditSectionModel {
    /**
     * id of the section
     */
    identifier: string;
    /**
     * A list of optional sub fields
     */
    fields: QuickEditFieldModel[];
}

export class QuickEditSectionModel implements IQuickEditSectionModel {
    public identifier: string;
    public fields: QuickEditFieldModel[];
    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IQuickEditSectionModel);
    constructor(obj?: any) {
        this.identifier = obj && obj.identifier || '';
        this.fields = [];
        if (obj && obj.fields !== undefined) {
            obj.fields.forEach((field: QuickEditFieldModel) => {
                this.fields.push(new QuickEditFieldModel(field));
            });
        }
    }
}
